import React, { useState } from 'react'
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material'
import { commonRadioStyles } from '../../../../common/InputStyles'
import { ModalFooter } from '../../../../../../../common/components/wizard/ModalFooter'
import * as Yup from 'yup'
import { SimpleErrorMessage } from '../../../../common/SimpleErrorMessage'
import { reportCategories } from 'common/types/ReportProfile'

const validationSchema = Yup.object().shape({
  reportCategory: Yup.string().oneOf(
    reportCategories.map((c) => c.id),
    'You must select one option',
  ),
})

const typographyProps = {
  typography: { color: '#101828', fontSize: { xs: '12px', md: '16px' } },
}

type Step1ReportCategoryProps = {
  reportCategory: (typeof reportCategories)[number]['id'] | null
  setReportCategory: (
    reportCategory: (typeof reportCategories)[number]['id'] | null,
  ) => void
}

// NOTE: It's such a simple component that we don't need RHF here

export const Step1ReportCategory = ({
  reportCategory,
  setReportCategory,
}: Step1ReportCategoryProps) => {
  const [error, setError] = useState<Yup.ValidationError | null>(null)

  const handleRadioSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    setReportCategory(
      event.target.value as (typeof reportCategories)[number]['id'],
    )
    setError(null)
  }

  const doValidation = async () => {
    try {
      await validationSchema.validate({ reportCategory })
      setError(null)
      return true
    } catch (error) {
      setError(error)
      return false
    }
  }

  return (
    <>
      <FormControl>
        <FormLabel id='report-type-radio-group-label'>
          {/* TODO: no time to figure out how to style the FormLabel, so this is a TW quick hack */}
          <p className='text-[#25395C] mb-4 text-sm sm:text-base font-normal sm:font-medium tracking-wide'>
            What would you like to report?
          </p>
        </FormLabel>
        <RadioGroup
          aria-labelledby='report-type-radio-group-label'
          value={reportCategory || null}
          onChange={handleRadioSelect}
        >
          {reportCategories.map(({ id, label }) => (
            <FormControlLabel
              key={id}
              value={id}
              control={<Radio sx={commonRadioStyles} />}
              label={label}
              componentsProps={typographyProps}
            />
          ))}
        </RadioGroup>
      </FormControl>
      {error && <SimpleErrorMessage message={error.message} />}
      <ModalFooter backButtonHide={true} doBeforeNextStep={doValidation} />
    </>
  )
}
